import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-link-modal',
    templateUrl: './link-modal.component.html',
    styleUrls: ['./link-modal.component.scss'],
    standalone: false
})
export class LinkModalComponent {
  @Input() public data: any[];
}
